import type { LegalCategory, LegalPageSummary } from '~/content/legal';
import type { TermsGroup } from '~/content/terms';

/** Group order and headings on /terms, keyed by the legal page `category`. */
const TERMS_INDEX_GROUPS: ReadonlyArray<{ category: LegalCategory; title: string }> = [
  { category: 'key', title: 'Key Terms' },
  { category: 'modules', title: 'Modules' },
  { category: 'other', title: 'Other Terms' },
  { category: 'policy', title: 'Policies' },
];

/** `/terms/cookie` is a code route rather than a legal page, so it has no CMS checkbox. */
const COOKIE_POLICY_LINK = { label: 'Cookie Policy', href: '/terms/cookie' };

/**
 * Build the /terms index from the published legal pages editors ticked
 * "Show on Terms & Conditions page" for, grouped by category and ordered by
 * `sortOrder`.
 */
export function termsIndexGroups(pages: LegalPageSummary[]): TermsGroup[] {
  const listed = pages.filter((page) => page.showOnIndex);
  return TERMS_INDEX_GROUPS.map(({ category, title }) => {
    const links = listed
      .filter((page) => page.category === category)
      .sort((a, b) => a.sortOrder - b.sortOrder || a.title.localeCompare(b.title))
      .map((page) => ({ label: page.indexLabel ?? page.title, href: `/${page.fullPath}` }));
    return { title, links: category === 'other' ? [...links, COOKIE_POLICY_LINK] : links };
  }).filter((group) => group.links.length > 0);
}
